import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(2),

    '& .MuiTypography-root': {
      fontSize: theme.spacing(1.75),
    },
  },

  title: {
    '&.MuiTypography-root': {
      fontWeight: 'bold',
    },
  },
}));
